module.exports = "/wwwroot/img/one_and_two_columns_content_block.png?ver=e6e1f1bc";